/* eslint-disable react/display-name */
import { FieldTypes } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { forwardRef } from "react";
import RequiredStar from "@/app/components/lib/RequiredStar";
import InputErrorMsg from "../../../form-builder-helpers/InputErrorMsg";


interface Props {
  label: string;
  value?: any;
  type?: FieldTypes;
  dir?: "ltr" | "rtl" | "auto";
  errorMsg?: string;
  onClick?: () => void;
  onChange?: () => void;
  isRequired: boolean;
  hideLabel?: boolean;
  hint?: string;
}

const FloatingInput = forwardRef<HTMLInputElement, Props>(
  (
    {
      value,
      onClick,
      isRequired,
      onChange,
      label,

      dir = "auto",
      errorMsg,
      hideLabel,
      hint,
    },
    ref,
  ) => {
    return (
      <>
        <div className="form-floating mb-3">
          <input
            className="form-control"
            id="floatingInput"
            readOnly
            onClick={onClick}
            onChange={onChange}
            value={value}
            ref={ref}
            placeholder={label}
            dir={dir}
            autoComplete="new-password"
          />
          <label htmlFor="floatingInput">
            {!hideLabel && (
              <span>
                <RequiredStar title={label} isRequired={isRequired} />
              </span>
            )}
          </label>
          {hint && <div className="field-hint">{hint}</div>}
          {errorMsg && <InputErrorMsg errorMsg={errorMsg} />}
        </div>
      </>
    );
  },
);

export default FloatingInput;
